module.exports = __webpack_public_path__ + "img/default.cb536586.jpg";